import * as designScreenActions from '../../../actions/Screen';
import * as treePackageActions from './Packages';
import {activeCodes} from '../../../../../../constants/FieldConsts';
import * as fieldTypes from '../../../../../../constants/FieldTypes';

let getPaintedDataFunc;

export function initFunctions(funcs) {
    if (funcs) {
        getPaintedDataFunc = funcs.getPaintedData;
    }
}

export function getData(screen) {
    const {collection, changed} = screen;
    const {isEmpty} = collection;
    if (isEmpty) {
        getPaintedDataFunc && getPaintedDataFunc();
    } else if (changed) {
        /* that means that we need to overwrite some unsaved changes */
        screen.setChanged(false);
        getPaintedDataFunc && getPaintedDataFunc();
    } else {
        /* we get here if there're packages changed in other screens */
        // we can't get updated data for TREE screen due to backend restrictions;
        // so we simulate the update on client side
        updatePaintedData(screen);
        screen.setLoading(false);
    }
}

export function updatePaintedData(screen) {
    if (screen.packagesChanged) {
        screen.setPackagesChanged(false);
        treePackageActions.updateFieldsHiddenStatus(screen.collection);
    }
}

export function createNewTab(screen) {
    //const { selectedScreen } = screensStore;
    const {changed} = screen;
    if (!disableNewTabBtn(screen)) {
        const field = screen.collection.createNewField(
            {type: fieldTypes.TAB, isChanging: true, name: screen.collection.nextId},
            screen
        );
        screen.collection.setField(field, screen.collection.firstHiddenIdx);
        // activate added field
        designScreenActions.activateField(
            screen.collection.fields[screen.collection.firstHiddenIdx - 1]
        );
        if (!changed) {
            screen.setChanged(true);
        }
    }
}

export function disableNewTabBtn(screen) {
    return screen.active && screen.active.isChanging;
}

export function changePicDesign(designScreen) {
    designScreen.setChanged(true);
    designScreen.setPicDesign(
        designScreen.picdesign === activeCodes.ACTIVE ? activeCodes.INACTIVE : activeCodes.ACTIVE
    );
}
